var _path, _circle, _circle2, _rect, _rect2, _path2, _rect3, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEstateDistribution = function SvgEstateDistribution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195,
    height: 94,
    fill: "none",
    viewBox: "0 0 195 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M0 0h194.333v94H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.217,
    cy: 26.344,
    r: 8,
    fill: "#4B5563"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.217,
    cy: 26.344,
    r: 8,
    fill: "#4B5563"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 59.683,
    y: 59.656,
    fill: "#4B5563",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 88.65,
    y: 59.656,
    fill: "#4B5563",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    d: "M99.217 43.344v16"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 118.65,
    y: 59.656,
    fill: "#4B5563",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    d: "M129.217 59.344v-3.237a4 4 0 0 0-4-4h-22a4 4 0 0 1-4-4v-4.763"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    d: "M115.217 34.344v2.332a4 4 0 0 1-4 4h-8a4 4 0 0 0-4 4v3.668M83.217 34.344v2.332a4 4 0 0 0 4 4h8a4 4 0 0 1 4 4v3.668"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    d: "M69.217 59.344v-3.237a4 4 0 0 1 4-4h22a4 4 0 0 0 4-4v-4.763"
  })));
};
export default SvgEstateDistribution;